/* eslint-disable prettier/prettier */
//当前文件作为全局注册组件使用
import Vue from "vue";
import PreviewImage from "../../components/previewImage";
import Tooltip from "@/components/tooltip";

// register globallyComponent

// 使用方法
{
    /* <preview-image
        :images="images"
        :previewIndex="1"
        valueKey="src"
        ></preview-image> */
}
Vue.component("preview-image", PreviewImage);
Vue.component("Tooltip", Tooltip);
